import classNames from 'classnames'
import React from 'react'

export default function BounceIndicador({ active = false }) {
  const classes = classNames({
    spinner: true,
    'ml-4': true,
    'd-inline-block': active,
    'd-none': !active
  })

  return (
    <span className={classes}>
      <span className="bounce1 bg-primary" />
      <span className="bounce2 bg-primary" />
      <span className="bounce3 bg-primary" />
    </span>
  )
}
